module.exports = __webpack_public_path__ + "static/media/blogimage.e8ccab8a.jpg";